import type { ReactElement } from 'react';

/**
 * Légende du vert (QD-009) — la même phrase sur le Restant et sur la fiche.
 *
 * Elle empêche la lecture « vert = réglé » : l'appariement constate qu'une
 * référence existe des deux côtés, il ne compare pas les quantités. Aucune
 * règle d'appariement ne change ; seule la lecture est cadrée.
 */
export function LegendeVert(): ReactElement {
  return (
    <p className="sous-titre legende" role="note">
      <span className="pastille pastille--vert" aria-hidden="true" /> Vert = la référence existe des
      deux côtés. Les quantités se vérifient dans l&apos;écart de l&apos;article ou de la famille.
    </p>
  );
}
